import { useMutation } from "react-query";
import http from "infra/http";

function useCheckoutParticipante({
  votacaoId,
  pessoaId,
}: {
  votacaoId: string;
  pessoaId: string;
}) {
  return useMutation(
    (unidadeId?: string) => {
      return http.post(`/v1/votacao/${votacaoId}/participantes/checkout`, {
        pessoaId,
        unidadeId,
      });
    },
    { retry: false }
  );
}

export default useCheckoutParticipante;
